import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import AlarmRepair from '../alarm-repair-tool/index.vue';
import CrowdRoi from '@blade-sxp/monitor/components/crowd-roi/index.vue';
import { TaskType } from '@blade-sxp/monitor/interfaces/control';
import taskType from '@blade-sxp/monitor/lang/task-type';
import { getAlertFont } from '@blade-sxp/monitor/utils/transforms';
import Description from './description.vue';
let default_1 = class default_1 extends Vue {
    dialogItem;
    task_type7 = true;
    showBackground = true;
    showDirectionStatus = true;
    showHotStatus = true;
    listLength = 0;
    crowdList = [];
    count = 0;
    toolBoxStatus = false;
    get taskConfig() {
        return JSON.parse(this.dialogItem.taskConfig);
    }
    get warningHead() {
        const { taskType, alertType } = this.dialogItem;
        return this.$t(getAlertFont(taskType, alertType));
    }
    get isDistanceTooClose() {
        return this.dialogItem.taskType === TaskType.DistanceTooClose;
    }
    get viewHotStatus() {
        return this.dialogItem.taskType === TaskType.Crowded;
    }
    get viewDirectionStatus() {
        return this.dialogItem.taskType === TaskType.CrossLine;
    }
    closeDialog() {
        this.$emit('closedialogs');
    }
    colorfulEgg() {
        this.count++;
        if (this.count >= 5) {
            this.toolBoxStatus = true;
        }
    }
    alarmRepairClose() {
        this.toolBoxStatus = false;
        this.count = 0;
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogItem", void 0);
default_1 = __decorate([
    Component({
        name: 'distance',
        components: {
            AlarmRepair,
            CrowdRoi,
            Description,
        },
        i18n: {
            messages: {
                'en-us': {
                    name: 'Name',
                    position: 'Position',
                    regionalInvasion: 'Regional Invasion',
                    faceControlRatio: 'Facial Matched Result',
                    overflowOfPeople: 'Overflow Of People',
                    crowded: 'Overcrowding Alert',
                    crowdgathering: 'Crowd Gathering',
                    crowdSpreadOut: 'Crowd Spread out',
                    crowdCountercurrent: 'Crowd Countercurrent',
                    crowdRetention: 'Crowd Retention',
                    distanceTooClose: 'Social distance too close',
                    missionName: 'Task Name',
                    taskType: 'Task Type',
                    deviceName: 'Device Name',
                    triggerTime: 'Created Time',
                    threshold: 'Threshold',
                    portraitLibrary: 'Portrait Library',
                    idPicture: 'ID Photo',
                    liveAvatar: 'Live Avatar',
                    detentionTimeThreshold: 'Loitering Time Threshold',
                    currentNumber: 'Current Number',
                    LengthOfStay: 'Length of Stay',
                    people: 'People',
                    direction: 'Statistical Direction',
                    statisticalTime: 'Statistical Time',
                    overrunThreshold: 'Overrun Threshold',
                    statistics: 'Statistics',
                    crossLine: 'Cross Line Direction Indicator',
                    numberOfpeople: 'Number Of People',
                    crowdDensity: 'Crowd Density',
                    distance: 'Distance',
                    duration: 'Duration',
                    alarmMethod: 'Alarm Method',
                    numberOfUpstream: 'Number Of Upstream',
                    positiveDirection: 'Positive Direction Indicator',
                    heatMap: 'Heat Map',
                    warningCrowded: 'Overcrowding Alert',
                    warningRegional: 'Regional Intrusion Warning',
                    warningReflux: 'Crowd Reflux Warning',
                },
                zh: {
                    name: '姓名',
                    position: '位置',
                    regionalInvasion: '区域入侵',
                    faceControlRatio: '人脸布控比中',
                    overflowOfPeople: '人流量超限',
                    crowded: '人群过密',
                    crowdgathering: '人群聚集',
                    crowdSpreadOut: '人群散开',
                    crowdCountercurrent: '人群逆流',
                    crowdRetention: '人群滞留',
                    distanceTooClose: '社交距离过近',
                    missionName: '任务名称',
                    taskType: '任务类型',
                    deviceName: '设备名称',
                    triggerTime: '触发时间',
                    threshold: '阈值',
                    portraitLibrary: '人像库',
                    idPicture: '证件头像',
                    liveAvatar: '现场头像',
                    detentionTimeThreshold: '滞留时长阈值',
                    currentNumber: '当前人数',
                    LengthOfStay: '滞留时长',
                    people: '人',
                    direction: '统计方向',
                    statisticalTime: '统计时长',
                    overrunThreshold: '超限阈值',
                    statistics: '统计人数',
                    crossLine: '跨线方向标识',
                    numberOfpeople: '人数',
                    crowdDensity: '人群密度',
                    distance: '距离',
                    duration: '时长',
                    alarmMethod: '告警方式',
                    numberOfUpstream: '逆流人数',
                    positiveDirection: '正方向标识',
                    heatMap: '热力图',
                    warningCrowded: '人群过密告警',
                },
            },
            sharedMessages: taskType
        },
    })
], default_1);
export default default_1;
